const categoryNames = ['Fitness', 'Dance', 'Knowledge', 'Life'] as const;
type CategoryName = typeof categoryNames[number];

interface Categories {
  [key: number]: CategoryName;
}

export const CategoriesForPose: Categories = {
  1: 'Fitness',
  2: 'Dance',
};

export const CategoriesForExplanation: Categories = {
  4: 'Knowledge',
  5: 'Life',
};
